import { Button, Section } from "@arp/react-ndbx";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import React, { useEffect } from "react";
import Page from "../../../components/Page";
import { RetrieveOnlineButtonStack } from "../../../components/organisms/RetrieveOnlineButtonStack";
import { Application } from "../../../config/const/enums";
import {
  retrieveCommonDisclaimer,
  retrieveExpiredDisclaimer,
} from "../../../config/disclaimers/disclaimers";
import { queryKeys } from "../../../hooks/dataHooks/queryKeys";
import { useGetQuote } from "../../../hooks/dataHooks/useGetQuoteData";
import usePreQualificationPages from "../../../hooks/usePreQualificationPages";
import { backToQuotePoint } from "../../../utilities/utils";
import { trackifyPageChange } from "@allianz/tracking";

function RetrieveOutcomeExpired() {
  const queryClient = useQueryClient();
  const { state } = usePreQualificationPages();
  const { currentPage } = { ...state };
  const { data: quoteData, isLoading: quoteIsLoading } = useGetQuote();
  const retrieveQuoteTokenDetail = queryClient.getQueryData([
    queryKeys.RETRIEVE_QUOTE_TOKEN_DETAIL,
  ]);

  useEffect(() => {
    trackifyPageChange(currentPage?.identifier?.toLowerCase());
  }, []);

  return (
    <Page title={currentPage.title} identifier={currentPage.identifier}>
      <Section md={7} mb={4} mt={{ xs: 10, md: 15 }}>
        <Section mb={3}>
          <Typography variant="h2">
            {retrieveCommonDisclaimer.SORRY_DISCLAIMER}
          </Typography>
        </Section>
        <Section>
          <Typography variant="label-large">
            {retrieveCommonDisclaimer.QUOTE_REFERENCE}
          </Typography>
          <Typography variant="label-large-bold">
            {state.application === Application.CONTACT_CENTER
              ? quoteData?.quoteInformation?.quoteNumber
              : retrieveQuoteTokenDetail?.quoteNumber}
          </Typography>
        </Section>
        <Section sx={{ mt: 5, mb: { xs: 3, sm: 4 } }}>
          <Section sx={{ maxWidth: { xs: 334 }, mb: 0 }}>
            <img
              width="100%"
              src="https://www.allianzretireplus.com.au/content/dam/onemarketing/azau/allianz-life-dam/images/woman_laptop_headset.svg"
            ></img>
          </Section>
        </Section>

        <Section mb={3}>
          <Typography variant="h5">
            {"PP" === quoteData?.state?.processStatus
              ? retrieveExpiredDisclaimer.APPLICATION_POSTPONED
              : "D" === quoteData?.state?.processStatus
                ? ""
                : retrieveExpiredDisclaimer.APPLICATION_EXPIRED}
          </Typography>
        </Section>

        <Section mt={3} mb={3} sx={{ textAlign: "left" }}>
          <Typography variant="p3">
            {state.application === Application.CONTACT_CENTER
              ? retrieveExpiredDisclaimer.EXPIRED_DISCLAIMER_CC
              : "PP" === quoteData?.state?.processStatus
                ? retrieveExpiredDisclaimer.EXPIRED_PP_DISCLAIMER_ONLINE
                : "D" === quoteData?.state?.processStatus
                  ? retrieveExpiredDisclaimer.EXPIRED_D_DISCLAIMER_ONLINE
                  : retrieveExpiredDisclaimer.EXPIRED_DISCLAIMER_ONLINE}
          </Typography>
        </Section>
      </Section>
      {state.application === Application.CONTACT_CENTER ? (
        <Section mt={9} md={4} mb={12}>
          <Button
            id="cc-processing-continue"
            ariaLabel="continue"
            variant="contained"
            color="primary"
            size="medium"
            onClick={() => backToQuotePoint(Application.CONTACT_CENTER)}
            type="button"
          >
            {retrieveCommonDisclaimer.CLOSE}
          </Button>
        </Section>
      ) : (
        <Section md={10} mt={9} mb={12}>
          <RetrieveOnlineButtonStack
            backToQuotePoint={backToQuotePoint}
            showCallButton={"D" === quoteData?.state?.processStatus ? true : false}
          />
        </Section>
      )}
    </Page>
  );
}

export default RetrieveOutcomeExpired;
